import React from 'react';

interface CategoryTabsProps {
    categories: string[];
    selected: string | null;
    onSelect: (category: string | null) => void;
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({categories, selected, onSelect}) => {
    return (
        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-medium">
            <button
                type="button"
                onClick={() => onSelect(null)}
                className={`pb-1 transition-colors ${
                    selected === null
                        ? 'text-mld-text-primary border-b-2 border-mld-primary'
                        : 'text-gray-500 hover:text-mld-menu-text'
                }`}>
                All Products
            </button>
            {categories.map((cat) => (
                <button
                    key={cat}
                    type="button"
                    onClick={() => onSelect(cat)}
                    className={`pb-1 transition-colors ${
                        selected === cat
                            ? 'text-mld-text-primary border-b-2 border-mld-primary'
                            : 'text-gray-500 hover:text-mld-menu-text'
                    }`}>
                    {cat}
                </button>
            ))}
        </nav>
    );
};

export default CategoryTabs;
